import React, { MutableRefObject, useEffect, useState } from "react";
import { Box, Input, FormLabel, Flex, Text, Icon, List } from "@chakra-ui/react";
import { PropertyFormProps, SubPropertyProps } from "./Property.types";
import { PROPERTIES } from '../../../assets/schema/property';
import PropertyItem from "./PropertyItem";
import { BsArrowLeft } from "react-icons/bs";

export default function PropertyForm({ 
    property, onChange, onToggleView, onRef, onClose }: PropertyFormProps & 
    { onToggleView: () => void; onRef?: MutableRefObject<null>; onClose: () => void }) {
    const [propName, setPropName] = useState(property ? property.name : "")
    const [propType, setPropType] = useState(property ? property.type : "")
    const [activePropertyType, setActivePropertyType] = useState<SubPropertyProps>({label: '', icon: undefined, tooltipText: ''});

    function handlePropNameChange(e: React.ChangeEvent<HTMLInputElement>) {
        const value = e.target.value;        
        setPropName(value);
    }

    function handlePropTypeChange(value: string) {
        setPropType(value);
        
        if (propName) {
          onChange && onChange({ ...property, label: propName, type: value });
        }
    }

    function handleBlur() {
        onChange && onChange({ ...property, label: propName, type: propType });
    }

    function handleKeyPress(event: React.KeyboardEvent<HTMLInputElement>) {
        const key = event.key;

        if (key === 'Enter') {
            onChange && onChange({ ...property, name: propName });
            onClose();
        }
    }

    function handleBackView() {
        console.log({ onChange, onClose, propName, property });
        
        if (typeof propName !== 'undefined') {
            onChange && onChange({ ...property, name: propName });
            onClose();
        } else {
            onClose();
        }
    }

    useEffect(() => {
        const prop = PROPERTIES?.find(item => item?.label.toLowerCase() === propType.toLowerCase());

        setActivePropertyType(prop!)
    }, [propType]);

    console.log({ propName, propType });
    
    return (
       <Box onBlur={handleBackView}>
            <>
                <Flex 
                    onClick={handleBackView}  
                    className="pointer" 
                    alignItems='center' 
                    marginBottom={'1.5'} 
                    padding='1rem 0rem 0.5rem 0.5rem' 
                >
                    <Icon as={BsArrowLeft} fontWeight={'normal'} size={'sm'} color='gray.500' marginRight={'1'}  />
                    <Text color='gray.600'>Edit property</Text>
                </Flex>
                <Box paddingX='0.5rem'>
                    <Input 
                        size='sm' 
                        ref={onRef}
                        value={propName} 
                        marginBottom='1rem'
                        onBlur={handleBlur}
                        borderRadius='md'
                        onChange={handlePropNameChange}
                        onKeyDownCapture={handleKeyPress}
                        placeholder="Enter property name"
                    />
                </Box>
            </>
            <Box>
                <FormLabel fontSize='sm' paddingX='0.5rem' fontWeight={'semibold'}>
                    Type
                </FormLabel>
                <List spacing={'2'}>
                    {PROPERTIES.map((prop, index) => (
                        <PropertyItem 
                            activePropertyType={activePropertyType} 
                            key={index} 
                            onClick={handlePropTypeChange} 
                            {...prop} 
                        />
                    ))}
                </List>
            </Box>
       </Box>
    )
}